(function(){
  const LIST_SEL = '.m-stars';
  const PDP_SEL  = '.product-detail-thumbnail-stars';

  /* 심벌 보장 */
  function ensureSymbols(){
    if(document.getElementById('oke-star-empty')&&document.getElementById('oke-star-filled')) return;
    const s=document.createElementNS('http://www.w3.org/2000/svg','svg');
    s.setAttribute('aria-hidden','true');s.setAttribute('focusable','false');
    s.setAttribute('style','position:absolute;width:0;height:0;overflow:hidden');
    s.innerHTML =
      '<symbol id="oke-star-empty" viewBox="0 0 14 14"><path fill="currentColor" d="M7 0l2.1 4.3 4.8.7-3.5 3.4.8 4.7L7 11.8 2.8 13.1l.8-4.7L0 5l4.8-.7z"/></symbol>'+
      '<symbol id="oke-star-filled" viewBox="0 0 14 14"><path fill="currentColor" d="M7 0l2.1 4.3 4.8.7-3.5 3.4.8 4.7L7 11.8 2.8 13.1l.8-4.7L0 5l4.8-.7z"/></symbol>';
    document.body.appendChild(s);
  }

  /* 유틸 */
  const getPid=(el)=>{ if(el?.dataset?.productId) return el.dataset.productId; let p=el?.parentElement; while(p){ if(p.dataset?.productId) return p.dataset.productId; p=p.parentElement } return null; };
  async function fetchScoreByPid(pid){
    const url=`https://monteranc-ab1e9ed451b4.herokuapp.com/yotpo/api/reviews/productScore?productId=${encodeURIComponent(pid)}`;
    const r=await fetch(url,{credentials:'omit'}); if(!r.ok) throw new Error(r.status);
    const j=await r.json(); const b=j.productScore||{};
    return { avg:Number(b.average_score||0), count:Number(b.total_reviews||0) };
  }
  function readExistingScore(){
    if(!document.body.classList.contains('template-product')) return null;
    const avgEl=document.getElementById('productScoreReviewTextRevBar');
    const cntEl=document.querySelector('.overall-rating .reviews-count');
    const avg=avgEl?parseFloat(avgEl.textContent.trim()):NaN;
    let count=NaN; if(cntEl){ const m=cntEl.textContent.replace(/\u00A0/g,' ').match(/([\d,]+)/); if(m) count=parseInt(m[1].replace(/,/g,''),10); }
    return (Number.isFinite(avg)&&Number.isFinite(count)) ? {avg,count} : null;
  }
  const comma=(n)=>(Number(n)||0).toLocaleString('en-US');

  /* 렌더러(5개 SVG + 좌→우 클립) */
  const renderStars = (el, avg, count)=>{
    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
    const comma=(n)=>(Number(n)||0).toLocaleString('en-US');
    const a=clamp(Number(avg)||0,0,5);
    const pct=(a/5)*100;
    const avgStr=a.toFixed(1);

    const BOX_W=65, H=11, STAR_W=11, GAP=2.5;
    const xs=[0, STAR_W+GAP, 2*(STAR_W+GAP), 3*(STAR_W+GAP), 4*(STAR_W+GAP)]; // 0,15.25,30.5,45.75,61.0
    const uid='mrmsk_'+Math.random().toString(36).slice(2);

    const starPath='M7 0l2.1 4.3 4.8.7-3.5 3.4.8 4.7L7 11.8 2.8 13.1l.8-4.7L0 5l4.8-.7z';
    const scale=(H/14).toFixed(6); // 11/14

    const svg=
      '<svg viewBox="0 0 65 11" aria-hidden="true" role="img">'+
        '<defs>'+
          '<path id="mr-star" d="'+starPath+'" transform="scale('+scale+')"></path>'+
          '<mask id="'+uid+'">'+
            '<rect width="'+BOX_W+'" height="'+H+'" fill="black"></rect>'+
            '<g fill="white">'+
              '<use href="#mr-star" x="'+xs[0]+'"></use>'+
              '<use href="#mr-star" x="'+xs[1]+'"></use>'+
              '<use href="#mr-star" x="'+xs[2]+'"></use>'+
              '<use href="#mr-star" x="'+xs[3]+'"></use>'+
              '<use href="#mr-star" x="'+xs[4]+'"></use>'+
            '</g>'+
          '</mask>'+
        '</defs>'+
        '<rect width="'+BOX_W+'" height="'+H+'" fill="#c8c8c8" mask="url(#'+uid+')"></rect>'+
        '<rect width="'+(BOX_W*pct/100)+'" height="'+H+'" fill="#000000" mask="url(#'+uid+')"></rect>'+
      '</svg>';

    el.innerHTML=
      '<span class="mr-stars" aria-label="Rating '+avgStr+' out of 5">'+
        '<span class="mr-stars__box">'+ svg +'</span>'+
        '<span class="mr-stars__avg">'+avgStr+'</span>'+
        '<span class="mr-stars__cnt">('+comma(count)+')</span>'+
      '</span>';

    if(!el.hasAttribute('role')) el.setAttribute('role','button');
    if(!el.hasAttribute('tabindex')) el.setAttribute('tabindex','0');
    el.setAttribute('aria-label','See reviews, rating '+avgStr+' out of 5, '+comma(count)+' reviews');
  };

  /* 페인트 */
  async function paintList(el){
    if(!el || el.dataset.mrBound==='1') return; el.dataset.mrBound='1';
    const dataAvg=parseFloat(el.getAttribute('data-rating'));
    const dataCnt=el.getAttribute('data-reviews');
    if(!Number.isNaN(dataAvg) && dataCnt!=null){ renderStars(el,dataAvg,dataCnt); return; }
    const pid=getPid(el); if(!pid) return;
    const v=await fetchScoreByPid(pid); renderStars(el,v.avg,v.count);
  }
  async function paintPdp(el){
    if(!el || el.dataset.mrBound==='1') return; el.dataset.mrBound='1';
    const reuse=readExistingScore();
    if(reuse){ renderStars(el,reuse.avg,reuse.count); return; }
    const pid=getPid(el); if(!pid) return;
    const v=await fetchScoreByPid(pid); renderStars(el,v.avg,v.count);
  }

  /* 상세만 리뷰 스크롤 */
  function bindPdpScroll(){
    const target =
      document.getElementById('check-media-title') ||
      document.getElementById('reviews') ||
      document.querySelector('.overall-rating');
    if(!target) return;

    const bind = (el)=>{
      if(!el || el.dataset.scrollBound==='1') return;
      el.dataset.scrollBound='1';
      const go=(e)=>{ e && e.preventDefault(); target.scrollIntoView({behavior:'smooth',block:'start'}); };
      el.addEventListener('click',go,{passive:false});
      el.addEventListener('keydown',(e)=>{ if(e.key==='Enter'||e.key===' ') go(e); });
    };

    const sels = [
      '.product-detail-thumbnail-stars',   // 별점 박스
      '#fabReview',                        // 새 플로팅 리뷰 버튼
      '#reviewButton',                     // 구 버튼(있으면 지원)
      '[data-action="go-reviews"]'         // 선택자 확장용(옵션)
    ];
    sels.forEach(sel => document.querySelectorAll(sel).forEach(bind));
  }

  /* 엔트리 */
  function init(){
    ensureSymbols();
    [...document.querySelectorAll(LIST_SEL)].forEach(paintList);
    [...document.querySelectorAll(PDP_SEL)].forEach(paintPdp);
    bindPdpScroll();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

// Bottome bar - GSAP + ScrollTrigger 필요
(function(){
  function getReviewTarget(){return document.getElementById('check-media-title')||document.getElementById('reviews')||document.querySelector('.overall-rating');}
  function getAddBtn(){return document.querySelector('form[action="/cart/add"] [type="submit"]')||document.querySelector('button[name="add"]');}

  function wireClicks(){
      var r=document.getElementById('fabReview'); if(r&&!r._bound){r._bound=1; r.addEventListener('click',function(e){e.preventDefault();var t=getReviewTarget();if(t) t.scrollIntoView({behavior:'smooth',block:'start'});});}
      var a=document.getElementById('fabAdd'); if(a&&!a._bound){a._bound=1; a.addEventListener('click',function(e){e.preventDefault();var b=getAddBtn(); if(b){b.click();}});}
  }

  function showBar(show){
    var bar=document.querySelector('.fab_bar'); if(!bar) return;
    if(window.gsap&&window.ScrollTrigger){
      gsap.to(bar,{bottom:show?0:-120,opacity:show?1:0,duration:show?.45:.35,ease:show?'power3.out':'power2.in',onStart:function(){if(show) bar.style.pointerEvents='auto';},onComplete:function(){if(!show) bar.style.pointerEvents='none';}});
    }else{
      bar.style.bottom=show?'0':'-120px'; bar.style.opacity=show?'1':'0'; bar.style.pointerEvents=show?'auto':'none';
    }
  }

  function mountFloatBar(){
    var bar=document.querySelector('.fab_bar'); if(!bar) return;
    wireClicks();

    var trigger=document.querySelector('.product__description')||document.querySelector('#ProductInfo-template--main')||document.querySelector('[data-product-info]')||document.body;

    if(window.gsap&&window.ScrollTrigger){
      try{gsap.registerPlugin(ScrollTrigger);}catch(_){}
      ScrollTrigger.create({
        trigger:trigger,
        start: 'top 80%',     
        end: 'bottom center',
        onEnter:function(){showBar(true); bar.setAttribute('aria-hidden','false');},
        onEnterBack:function(){showBar(true); bar.setAttribute('aria-hidden','false');},
        onLeave:function(){showBar(false); bar.setAttribute('aria-hidden','true');},
        onLeaveBack:function(){showBar(false); bar.setAttribute('aria-hidden','true');}
      });
    }else{
      showBar(true); // GSAP 없으면 그냥 계속 표시
    }
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mountFloatBar);}else{mountFloatBar();}
  window.addEventListener('shopify:section:load',mountFloatBar);
})();



